module.exports = __webpack_public_path__ + "static/media/budget_quote_UPDATE4.dda9cdf2.png";